function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fdd020"
}, /*#__PURE__*/React.createElement("path", {
  d: "m248 384c-79.527344 0-144-64.472656-144-144s64.472656-144 144-144"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120 120c-2.121094 0-4.15625-.84375-5.65625-2.34375l-48-48c-3.03125-3.140625-2.988281-8.128906.097656-11.214844 3.085938-3.085937 8.074219-3.128906 11.214844-.097656l48 48c2.285156 2.289062 2.972656 5.730469 1.734375 8.71875s-4.15625 4.9375-7.390625 4.9375zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72 248h-64c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h64c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72 424c-3.234375 0-6.152344-1.949219-7.390625-4.9375s-.550781-6.429688 1.734375-8.71875l48-48c3.140625-3.03125 8.128906-2.988281 11.214844.097656 3.085937 3.085938 3.128906 8.074219.097656 11.214844l-48 48c-1.5 1.5-3.535156 2.34375-5.65625 2.34375zm0 0"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m394.566406 304.550781c-56.949218-.65625-102.597656-47.328125-102-104.277343.316406-43.867188 27.21875-83.152344 68-99.304688-14.238281-3.84375-28.972656-5.515625-43.710937-4.96875-27.375.003906-54.128907 8.15625-76.855469 23.414062v241.171876c35.800781 24.007812 80.757812 29.933593 121.558594 16.019531 40.796875-13.914063 72.765625-46.070313 86.441406-86.949219-15.882812 10.28125-34.519531 15.480469-53.433594 14.894531zm0 0",
  fill: "#fce666"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m424 215.601562 29.664062 16.398438-5.664062-34.734375 24-24.59375-33.167969-5.070313-14.832031-31.601562-14.832031 31.601562-33.167969 5.070313 24 24.59375-5.664062 34.734375zm0 0",
  fill: "#ffde3d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m240 480c-4.417969 0-8-3.582031-8-8v-464c0-4.417969 3.582031-8 8-8s8 3.582031 8 8v464c0 4.417969-3.582031 8-8 8zm0 0",
  fill: "#92aeba"
});

var SvgSunsetSunrise = function SvgSunsetSunrise(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "-4 0 480 480",
    width: "480pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSunsetSunrise, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sunset-sunrise.da61a68b.svg";
export { ForwardRef as ReactComponent };